var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var HourglassBottom = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10 9.25C10.9028 9.25 11.6701 8.93403 12.3021 8.30208C12.934 7.67014 13.25 6.90278 13.25 6V3.5H6.75V6C6.75 6.90278 7.06597 7.67014 7.69792 8.30208C8.32986 8.93403 9.09722 9.25 10 9.25ZM4 18V16.5H5.25V14C5.25 13.1806 5.44444 12.4201 5.83333 11.7188C6.22222 11.0174 6.76389 10.4444 7.45833 10C6.77778 9.55556 6.23958 8.98264 5.84375 8.28125C5.44792 7.57986 5.25 6.81944 5.25 6V3.5H4V2H16V3.5H14.75V6C14.75 6.81944 14.5521 7.57986 14.1562 8.28125C13.7604 8.98264 13.2222 9.55556 12.5417 10C13.2361 10.4444 13.7778 11.0174 14.1667 11.7188C14.5556 12.4201 14.75 13.1806 14.75 14V16.5H16V18H4Z", fill: color }) })));
};
